import React from "react";

/** New refined transparent DEBSUN lockup (mark + wordmark + tagline). */
export const LOGO = "https://customer-assets-v7afamib.emergentagent.net/job_automation-hub-455/artifacts/ttpzkvex_DEBSUN%20logo.png";

/** Full logo image — used large (hero / boot / auth panels). */
export const LogoMark = ({ className = "", style }) => (
  <img src={LOGO} alt="DEBSUN Technologies" className={className} style={{ objectFit: "contain", ...style }} />
);

/** Crisp typographic wordmark for header / footer (stays legible at small sizes). */
export const LogoWord = ({ className = "", compact = false }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="logo-wordmark">
    <img
      src={LOGO}
      alt="DEBSUN Technologies"
      className="object-contain shrink-0"
      style={{ width: compact ? 26 : 30, height: compact ? 26 : 30 }}
    />
    <span className="leading-none">
      <span className="display text-lg tracking-tight">
        <span style={{ color: "var(--foreground)" }}>DEB</span>
        <span style={{ color: "var(--gold)" }}>SUN</span>
        {!compact && <span className="text-muted-foreground font-normal text-sm ml-1.5">Technologies</span>}
      </span>
      <span className="block font-mono-2 text-[8px] tracking-[0.32em] uppercase text-muted-foreground mt-1">
        Intelligence in Motion
      </span>
    </span>
  </div>
);

/** Custom engineering-truss glyph (Lucide-style, 24x24, stroke-based) —
 * abstracts structural precision via two parallel members and diagonal
 * cross-bracing. Deliberately not a track/rail motif. Used for the
 * "Engineering Foundations" facet in the Meaning section. */
export const EngineeringTruss = ({ size = 24, strokeWidth = 1.6, className = "", ...props }) => (
  <svg
    width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
    className={className} aria-hidden="true" {...props}
  >
    <line x1="6" y1="4" x2="6" y2="20" />
    <line x1="18" y1="4" x2="18" y2="20" />
    <path d="M6 4 L18 8 L6 12 L18 16 L6 20" />
  </svg>
);
